import { ChatMessageImage } from 'features/chat/types';

const BLOB_PREFIX = 'blob:';

export const collectOptimisticBlobUrls = (images: ChatMessageImage[] | undefined): string[] => {
  if (!images) {
    return [];
  }

  const urls: string[] = [];
  for (const image of images) {
    if (image.url.startsWith(BLOB_PREFIX)) {
      urls.push(image.url);
    }
    if (image.thumbnailUrl.startsWith(BLOB_PREFIX) && image.thumbnailUrl !== image.url) {
      urls.push(image.thumbnailUrl);
    }
  }
  return urls;
};
